export const selectSessionTitle = state =>
  state.SessionReducer.sessionTitle ||
  state.SessionReducer.sessionDetails.sessionName;
export const selectSessionStartTime = state =>
  state.SessionReducer.sessionDetails.startTime;
export const getCurrentSessionInvitees = state =>
  state.SessionReducer.currentSessionInvitees;
export const getIsSessionJoined = state => state.SessionReducer.isSessionJoined;
